import React from 'react';
import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="filter" {...props} />;
}

export const meta = {
  id: 'CMSCampaigns',
  title: 'CMS Campaigns',
  category: 'CMS',
  exposes: [
    {
      title: 'Campaigns',
      action: { module: 'CMSCampaigns', props: { /* */ } },
    },
    {
      title: 'New Campaign',
      action: { module: 'CMSCampaignsDetails', props: { context: 'add' } },
    },
  ],
  unique: true,
  icon: TheIcon,
  version: '1.0.0',
  description: `Manages the campaigns for the CMS within the current tenant`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
